import gql from 'graphql-tag';

import categoryFragment from '~/shared/graphql-queries/categories/category-fragment';

const findManyCategoryQuery = gql`
    query findManyCategoryQuery(
        $limit: Int = 20
        $filter: FilterFindManyCategoryInput
    ) {
        findManyCategoryQuery(
            filter: $filter
            skip: 0
            limit: $limit
            sort: _ID_ASC
        ) {
            ...CategoryFragment
        }
    }
    ${categoryFragment}
`;

export default findManyCategoryQuery;
